import { Center, Heading, Img, Text, VStack } from '@chakra-ui/react';
import { PrismicRichText } from '@prismicio/react';

import { PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';

export const ExplanationSection = () => {
  const { content } = usePageTextContent<BenefitsPageContent>();

  const { title, explanation, pictureUrl } = content.explanation;

  return (
    <PageContainer>
      <PageContent align="center" direction={['column', 'column', 'row']}>
        <VStack align="flex-start" spacing="1rem" minW="60%">
          <Heading fontSize="1.5rem">{title}</Heading>

          <PrismicRichText
            field={explanation}
            components={{
              paragraph: ({ children }) => (
                <Text fontSize="1.125rem" maxW="50rem">
                  {children}
                </Text>
              ),
            }}
          />
        </VStack>

        <Center
          h="full"
          w="full"
          maxWidth={['25rem', '25rem', '32rem']}
          mt={['2rem', '2rem', 0]}
          ml={[0, 0, 'auto']}
        >
          <Img src={pictureUrl} w="full" alt="Illustration" loading="lazy" />
        </Center>
      </PageContent>
    </PageContainer>
  );
};
